import commonStore from '../library/stores/commonStore';

const customerFeature = (featureName) => {
    if (!commonStore.config || !commonStore.config.biztype || !commonStore.config.biztype.data) return null;
    return commonStore.config.biztype.data[featureName];
};

export default customerFeature;
